import { apiCall } from "../helpers/api";


export const cities = (params = {}) => (dispatch) => {
  params.path = params.path || "regions/cities";
  return dispatch(apiCall(params));
}